import { P2GAlert, P2GText } from '@parcel2go/core-ui';
import { FilterName } from '../../lib/helpers/SmartSendFilterApplier';

import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  filterName: FilterName;
  wrapper: (x: React.ReactNode) => React.ReactNode;
}

const TabMessage: React.FC<props> = ({ filterName, wrapper }) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  if (filterName === 'Groupable') {
    return wrapper(
      <P2GAlert>
        <P2GText variant="body2">
          {t('GROUPABLE_TAB_MESSAGE', {
            defaultValue:
              'This tab shows orders that can be grouped together, converted to multi-parcel shipments, as well as other shipment options.'
          })}
        </P2GText>
      </P2GAlert>
    );
  }

  return null;
};

export default TabMessage;
